import { TAResponseProps } from 'types/TextAnalysis'
import { Tag } from '../Types'
import { storeInstance } from 'redux/store'

export const handleAddTagIcon = (
  index: number,
  setAnchorElMap: React.Dispatch<
    React.SetStateAction<{ [key: string]: HTMLElement | null }>
  >,
) => {
  const id = `action-card-${index + 1}`
  const anchroElement = document.getElementById(id?.toString() || '')
  if (anchroElement) {
    setAnchorElMap((prevState) => ({ ...prevState, [index]: anchroElement }))
  }
}

export const closeTagMenu = (
  index: number,
  setAnchorElMap: React.Dispatch<
    React.SetStateAction<{ [key: string]: HTMLElement | null }>
  >,
) => {
  setAnchorElMap((prevState) => ({ ...prevState, [index]: null }))
}

export const getOwnerType = (owner: { type: string }) => {
  return owner?.type.toLowerCase() || ''
}

export const removeTag = (index: number, tagToRemove: any) => {
  const latestData = storeInstance.getState().textAnalysis.data
  const latestTags = latestData[index]?.tags
  return latestTags.filter((tag: any) => tag.name !== tagToRemove.name)
}

export const handleAddNewTag = (
  item: TAResponseProps,
  tagToAdd: (string | Tag)[],
): any => {
  const { id, source_id } = item
  return {
    id,
    source_id,
    tags: tagToAdd,
  }
}

export const updateTagsImmediate = (index: any, tagToAdd: (Tag | string)[]) => {
  const latestData = storeInstance.getState().textAnalysis.data
  const newTags = [...(latestData[index]?.tags || []), tagToAdd]
  return newTags
}
